module.exports = __webpack_public_path__ + "static/img/no1.bb7300c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no1.png
// module id = CB+m
// module chunks = 31